// @flow

export default {
  DONE_PERCENTAGE: 80,
};
